<script lang="ts">
    import Modal from '@/components/Modal.svelte';
    import { Button } from '@/components/ui/button';
    import { SvelteMap } from 'svelte/reactivity';
    import { router } from '@inertiajs/svelte';
    import { toast } from 'svelte-sonner';
    import CustomerTable from './CustomerTable.svelte';

    type Props = {
        show: boolean;
        organisationId: string;
        currentContacts?: { id: string; name?: string }[];
    };

    let {
        show = $bindable(),
        organisationId,
        currentContacts = []
    }: Props = $props();

    let selectedContacts = $state(new SvelteMap<string, string>());
    let isSubmitting = $state(false);

    // Pre-populate with current contacts when modal opens
    $effect(() => {
        if (show) {
            selectedContacts.clear();
            currentContacts.forEach(contact => {
                selectedContacts.set(contact.id, contact.name || contact.id);
            });
        }
    });

    function handleSubmit() {
        isSubmitting = true;
        const selectedIds = Array.from(selectedContacts.keys());

        // Update each selected contact's organisation_id
        router.post(route('customers.link-contacts', { customer: organisationId }), {
            contact_ids: selectedIds
        }, {
            onSuccess: () => {
                show = false;
                toast.success('Contacts linked successfully!');
                // Refresh the page to show updated contacts list
                router.visit(route('customers.show', { customer: organisationId }));
            },
            onError: (errors) => {
                for (const message of Object.values(errors)) {
                    toast.error(`Error linking contacts: ${message as string}`);
                }
            },
            onFinish: () => {
                isSubmitting = false;
            },
            preserveScroll: true
        });
    }

    function close() {
        show = false;
    }
</script>

{#if show}
    <Modal title="Link Contacts to Organisation" onClose={close}>
        <div class="mt-4">
            <p class="text-sm text-muted-foreground mb-4">
                Select contacts to link to this organisation. Only contacts not already belonging to another organisation are shown.
            </p>
            <CustomerTable
                view="multi_related"
                bind:selectedCustomers={selectedContacts}
                onSubmitClick={handleSubmit}
                relatedData={{
                    column: 'available_for_organisation',
                    record_id: organisationId
                }}
            />
        </div>
    </Modal>
{/if}